import { someFields } from '../../../components/lets-form';

const formHasScript = form => {
  return someFields(form.fields, field => field.script != null);
};

export { formHasScript };
